import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDZmZITV2NIfBB-VIkl9mXYH9kznvZm3U0",
  authDomain: "eng102-research.firebaseapp.com",
  projectId: "eng102-research",
  storageBucket: "eng102-research.appspot.com",
  messagingSenderId: "325907418398",
  appId: "1:325907418398:web:6f255a8262deed5510cd0f",
  measurementId: "G-RHMVFKCJ9Q",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { analytics, auth, db };
